require("./app");
require("bootstrap");


require("slick-carousel");
require("@fancyapps/fancybox");


var slide_proyecto = $("#slide-incio").find('.contenido-inicio').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 3000,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.prev-arrow'),
    nextArrow: $('.next-arrow'),

})


$('#numero-slide-proyecto').html("01");
$('#logo-proyecto').html($('#slide-incio').find('.item_0').data('logo'));

slide_proyecto.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var logo = $(`.item_${nextSlide}`).data('logo');
    var numero = $(`.item_${nextSlide}`).data('numero');
    var item = `item_${nextSlide}`;


    $('#logo-proyecto').html(logo);
    if (item == "item_0") {
        $('#numero-slide-proyecto').html("01");
    } else {
        if (numero > 9) {
            $('#numero-slide-proyecto').html("" + numero);
        } else {
            $('#numero-slide-proyecto').html("0" + numero);
        }
        slide_logos_proyecto.slick('slickGoTo', nextSlide)
    }
});


var slide_logos_proyecto = $("#slide-logos").find('.contenido-slide-logos').slick({
    centerMode: true,
    centerPadding: 0,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $('.prev-arrow-logo'),
    nextArrow: $('.next-arrow-logo'),
    responsive: [
        {
            breakpoint: 992,
            settings: {
                centerMode: true,
                centerPadding: 0,
                slidesToShow: 3
            }
        },
        {
            breakpoint: 575,
            settings: {
                centerMode: false,
                centerPadding: 0,
                slidesToShow: 1
            }
        }
    ]
})

$('.contenido-slide-logos').find('.slick-center').find('.item').addClass('active');


slide_logos_proyecto.on('afterChange', function (event, slick, currentSlide, nextSlide) {
    $('.contenido-slide-logos').find('.slick-center').find('.item').addClass('active');
});
slide_logos_proyecto.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.contenido-slide-logos').find('.slick-center').find('.item').removeClass('active');
    slide_proyecto.slick('slickGoTo', nextSlide)

});


// SLIDE PROYECTOS DESTACADOS
$("#proyectos-destacados .items")
    .slick({
        arrows: false,
        autoplay: false,
        dots: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    })
    .on("afterChange", function (event, slick, num) {
        $("#proyectos-destacados .num-final").html("0" + (num + 1));
    });

$("#contacto .slide-regiones")
    .slick({
        arrows: false,
        autoplay: true,
        dots: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 4,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    })
    .on("afterChange", function (event, slick, num) {
        $("#contacto .num-final").html("0" + (num + 1));
    });



$("#proyectos-oportunidades .slide").slick({
    arrows: false,
    autoplay: false,
    dots: true,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1
});



// require("./modal_promocion");